<section>
  <div style="width: 100%;"><kendo-svg-icon [icon]="icons.exclamationCircleIcon"/></div>
  <h1>PAGE NOT FOUND</h1>
  <div class="buttons-container">
    <button kendoButton size="large" themeColor="primary" (click)="redirectToForm()">GO TO BOOKING FORM</button>
  </div>
</section>
